export const PDP_GALLERY_THUMBNAIL_IMAGE = 'pdp-gallery-thumbnail-image';
export const PDP_MAIN_IMAGE = 'pdp-main-image';
